import { render, staticRenderFns } from "./SearchSuggestions.vue?vue&type=template&id=cc5734d6&"
import script from "./SearchSuggestions.ts?vue&type=script&lang=ts&"
export * from "./SearchSuggestions.ts?vue&type=script&lang=ts&"
import style0 from "./SearchSuggestions.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports